import { Controller } from "@hotwired/stimulus"
import { ImageLinkHandler } from "./page_editor_modules/image_link_handler"

export default class extends Controller {
  connect() {
    this.imageLinkHandler = new ImageLinkHandler(this);
    this.imageLinkHandler.initializeImageLinkHandler();
    this.addNavbarToFirstSection();
  }

  addNavbarToFirstSection() {
    const existingNavbar = document.querySelector('nav.navbar, .navbar');
    const header = document.querySelector('header');

    if (existingNavbar && header) {
      existingNavbar.classList.remove('fixed-top');
      existingNavbar.style.position = 'absolute';
      existingNavbar.style.top = '0';
      existingNavbar.style.left = '0';
      existingNavbar.style.width = '100%';
      existingNavbar.style.zIndex = '1000';

      // Move navbar to header if it's not already there
      if (!header.contains(existingNavbar)) {
        header.appendChild(existingNavbar);
      }
    }
  }

  disconnect() {
    // Clean up if needed
    this.imageLinkHandler = null;
  }
}
